import WidgetComponent from "./components/WidgetComponent.js"
window.WidgetComponent = WidgetComponent;